<template>
    <div class="card mt-2" id="language">
        <div class="card-body">

            <div class="card-title font-weight-bold">
                Language & Proficiency
                <hr class="mt-1 border-dark"/>
            </div>

            <div class="form-group form-row mb-1" v-for="crewLanguage in crew.crew_languages" :key="crewLanguage.id">
                <label class="col col-sm-3 col-form-label font-weight-bolder text-left form-label-xs"
                       :for="'language' + crewLanguage.id"
                >
                    {{ crewLanguage.language.name }}:
                </label>
                <input type="text" readonly :id="'language' + crewLanguage.id"
                       class="col col-sm-4 form-control form-control-xs form-display h-1x"
                       :value="crewLanguage.efficiency.name"
                >
              <template v-if="(isManning || isDesignatedPrincipal || isPrincipal || isPrincipalStaff) && !guest && !isKline">
                <template v-if="crew.active == 1 || isSystemAdmin">
                  <div class="col col-sm-2">
                    <button class="btn btn-sm btn-xs"
                            data-toggle="modal" data-target="#editCrewLanguage"
                            :title="`EDIT ${crewLanguage.language.name} LANGUAGE`"
                            @click="updateCrewLanguageModal(crewLanguage)"
                    >
                      <span class="fas fa-edit"></span>
                    </button>
                    <button class="btn btn-sm btn-xs"
                            :title="`REMOVE ${ crewLanguage.language.name } LANGUAGE`"
                            @click="confirmDeleteCrewLanguage(crewLanguage.id)"
                    >
                      <span class="fas fa-minus text-danger"></span>
                    </button>
                  </div>
                </template>
              </template>

            </div>

          <template v-if="(isManning || isDesignatedPrincipal || isPrincipal || isPrincipalStaff) && !guest && !isKline">
            <template v-if="crew.active == 1 || isSystemAdmin">
              <div class="form-group form-row">
                <div class="col col-sm-1 offset-7">
                  <button class="btn btn-sm btn-xs"
                          title="ADD NEW CREW LANGUAGE"
                          data-toggle="modal" data-target="#newCrewLanguage"
                  >
                    <span class="fas fa-plus"></span>
                  </button>
                </div>
              </div>
            </template>
          </template>
        </div>

        <div class="modal fade" id="newCrewLanguage" tabindex="-1" role="dialog"
             aria-labelledby="newCrewLanguageTitle"
             aria-hidden="true" v-if="(isManning || isDesignatedPrincipal || isPrincipal || isPrincipalStaff)">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <form class="modal-content" @submit.prevent="confirmAddNewCrewLanguage">
                    <div class="modal-header">
                        <h5 class="modal-title font-weight-bolder" id="newCrewLanguageTitle">
                            New Crew Language
                        </h5>
                        <button type="button" id="closeNewCrewLanguage" class="close"
                                data-dismiss="modal" aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div class="modal-body">

                        <div class="form-group form-row mb-1" :class="{'has-error': newCrewLanguageErrors.language_id}">
                            <label class="col col-sm-3 col-form-label font-weight-bolder text-right" for="newLanguage" >
                                Language:
                            </label>

                            <div class="col col-sm-6">
                                <select id="newLanguage" required
                                        class="form-control form-control-xs"
                                        v-model="newCrewLanguage.language_id"
                                >
                                    <option :value="null">--- Select Language ---</option>
                                    <option v-for="languageKey in languageKeys" :key="languageKey.id"
                                            :value="languageKey.id"
                                    >
                                        {{ languageKey.name }}
                                    </option>
                                </select>
                                <span class="help-block" v-if="newCrewLanguageErrors.language_id !== ''">
                                    <small><strong>{{ newCrewLanguageErrors.language_id }}</strong></small>
                                </span>
                            </div>
                        </div>

                        <div class="form-group form-row mb-1" :class="{'has-error': newCrewLanguageErrors.efficiency_id}">
                            <label class="col col-sm-3 col-form-label font-weight-bolder text-right" for="newEfficiency" >
                                Efficiency:
                            </label>

                            <div class="col col-sm-6">
                                <select id="newEfficiency" required
                                        class="form-control form-control-xs"
                                        v-model="newCrewLanguage.efficiency_id"
                                >
                                    <option :value="null">--- Select Efficiency ---</option>
                                    <option :value="efficiencyKey.id" :key="efficiencyKey.id"
                                            v-for="efficiencyKey in efficiencyKeys"
                                    >
                                        {{ efficiencyKey.name }}
                                    </option>
                                </select>
                                <span class="help-block" v-if="newCrewLanguageErrors.efficiency_id !== ''">
                                    <small><strong>{{ newCrewLanguageErrors.efficiency_id }}</strong></small>
                                </span>
                            </div>


                        </div>
                    </div>

                    <div class="modal-footer">
                        <button type="submit" class="btn btn-sm btn-outline-primary font-weight-bolder">
                            <span class="fas fa-plus"></span>
                            Save
                        </button>
                    </div>

                </form>
            </div>
        </div>

        <div id="editCrewLanguage" class="modal fade"
             v-if="crewLanguage.language && (isManning || isDesignatedPrincipal || isPrincipal || isPrincipalStaff)"
             tabindex="-1" role="dialog" aria-labelledby="editCrewLanguageTitle" aria-hidden="true"
        >

            <div class="modal-dialog modal-dialog-centered" role="document">
                <form class="modal-content" @submit.prevent="confirmUpdateCrewLanguage">
                    <div class="modal-header">
                        <h5 class="modal-title font-weight-bolder" id="agencyNumberModalTitle">
                            UPDATE {{ crewLanguage.language.name }}
                        </h5>
                        <button type="button"
                                class="close"
                                data-dismiss="modal"
                                aria-label="Close"
                                id="closeCrewLanguage"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div class="modal-body">
                        <div class="form-group form-row mb-1" :class="{'has-error': crewLanguageErrors.efficiency_id}">
                            <label class="col col-sm-3 col-form-label font-weight-bolder text-right"
                                   for="languageEfficiency"
                            >
                                Efficiency:
                            </label>
                            <div class="col col-sm-6">
                                <select id="languageEfficiency" required
                                        class="form-control form-control-xs"
                                        v-model="crewLanguage.efficiency_id"
                                >
                                    <option :value="null">--- Select Efficiency ---</option>
                                    <option v-for="efficiencyKey in efficiencyKeys" :key="efficiencyKey.id"
                                            :value="efficiencyKey.id"
                                    >
                                        {{ efficiencyKey.name }}
                                    </option>
                                </select>
                                <span class="help-block" v-if="crewLanguageErrors.efficiency_id !== ''">
                                    <small><strong>{{ crewLanguageErrors.efficiency_id }}</strong></small>
                                </span>
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer">
                        <button type="submit" class="btn btn-sm btn-warning font-weight-bolder">
                            <span class="fas fa-edit"></span>
                            Update
                        </button>
                    </div>

                </form>
            </div>

        </div>

    </div>
</template>

<script>

    import { mapActions, mapGetters} from 'vuex';
    import { vueAppMixin } from "../../../../../../../mixins/vueAppMixin";
    import { formMixin} from "../../../../../../../mixins/formMixin";
    import {gateMixin} from "@/mixins/gateMixin";


    export default {
        name: "Language",
        mixins:[ vueAppMixin, formMixin, gateMixin ],
        data() {
            return {
                newCrewLanguage: {},
                crewLanguage: {},
                crewLanguageErrors: [],
                newCrewLanguageErrors: []
            }
        },

        methods: {
            ...mapActions([ 'getLanguageKeys', 'getEfficiencyKeys', 'addCrewLanguage', 'updateCrewLanguage', 'deleteCrewLanguage' ]),

            async confirmAddNewCrewLanguage() {
                if(await this.confirmCreateAlert()) {
                    let newCrewLanguage = await this.addCrewLanguage(this.newCrewLanguage);
                    if(newCrewLanguage) {
                        if(newCrewLanguage.errors) {
                            this.newCrewLanguageErrors = newCrewLanguage.errors;
                        } else {
                            this.successAlert('New Crew Language Successfully Added', 'CREATE');
                            this.refreshNewCrewLanguage();
                            document.getElementById('closeNewCrewLanguage').click();
                        }
                    }
                }
            },

            async confirmUpdateCrewLanguage() {
                if(await this.confirmUpdate()) {
                    let params = {
                        crewLanguageId: this.crewLanguage.id,
                        language_id: this.crewLanguage.language_id,
                        efficiency_id: this.crewLanguage.efficiency_id,
                        active: this.crewLanguage.active
                    };
                    let updatedCrewLanguage = await this.updateCrewLanguage(params);
                    if(updatedCrewLanguage) {
                        if(updatedCrewLanguage.errors) {
                            this.crewLanguageErrors = updatedCrewLanguage.errors;
                        } else {
                            this.successAlert('Crew Language Successfully Updated', 'UPDATE');
                            document.getElementById('closeCrewLanguage').click();
                        }
                    }
                }
            },

            async confirmDeleteCrewLanguage(crewlanguageId) {
                if(await this.confirmDeleteAlert()) {
                    if(await this.deleteCrewLanguage(crewlanguageId)) {
                        this.successAlert('Crew Language Successfully Deleted', 'DELETE');
                    }
                }
            },

            refreshNewCrewLanguage() {
                this.newCrewLanguage = { crew_id: this.$route.params.id, active: true, language_id: null, efficiency_id: null }
                this.newCrewLanguageErrors = [];
            },

            updateCrewLanguageModal(crewLanguage) {
                this.crewLanguage = Object. assign({}, crewLanguage);
            }

        },

        computed: {
            ...mapGetters([ 'crew', 'languageKeys', 'efficiencyKeys' ])
        },

        created() {

        },

        mounted() {
            this.getLanguageKeys();
            this.getEfficiencyKeys();
            this.refreshNewCrewLanguage();
        }
    }
</script>

<style scoped>

</style>
